import React from 'react';
import Portal from 'atoms/Portal/Portal';
import styles from './ToastsList.module.scss';
function ToastsList({ children }) {
    return (React.createElement(Portal, null,
        React.createElement("span", { className: styles.wrap }, children)));
}
export default ToastsList;
